export default "__VITE_ASSET__D3zcc0J5__"